module.exports = __webpack_public_path__ + "img/fallback_020_l.b0a7a408.jpg";